import { Href, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'

interface Props {
  flow: ContractFlow
  employeeFullName: string
}

const Footer = ({ flow, employeeFullName }: Props) => {
  const trackFooterLink = () => {
    track(trackingEvents.employee.contracts.goToFooterLink, {
      step: flow.currentStepNumber + 1,
      type: 'update',
    })
  }

  return (
    <Href
      onClick={() => trackFooterLink()}
      href={helpCenterUrl('manage_contracts_update')}
      target="_blank"
    >
      <Text.Normal weight="medium" size="100">
        {i18n.t('contract_versions.flows.fix.footer.content', {
          employeeFullName,
        })}
      </Text.Normal>
    </Href>
  )
}

export default Footer
